module.exports = __webpack_public_path__ + "img/meyers.d22819ae.png";